import { Link } from 'react-router-dom';
import Logo from './Logo';
import { SOCIAL_LINKS } from '../data/siteData';

export default function Footer({ aboutText }) {
  const description =
    aboutText ||
    'Desenvolvemos aplicativos e sistemas sob medida que automatizam processos, integram-se ao seu ERP e impulsionam a produtividade da sua empresa.';

  return (
    <>
      <a
        href="https://wa.me/5544991775641"
        className="in-wa"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="in-sr-only">Fale conosco pelo WhatsApp</span>
        <i className="ri-whatsapp-line" aria-hidden="true" />
      </a>
      <footer className="in-footer">
        <div className="in-container">
          <h2 className="in-sr-only">Rodapé</h2>
          <div className="in-footer__grid">
            <div>
              <Link to="/" className="in-footer__brand">
                <Logo />
              </Link>
              <p className="in-footer__desc">{description}</p>
            </div>
            <div>
              <h3 className="in-footer__heading">Empresa</h3>
              <ul>
                <li><Link to="/quem-somos-innovanow">Quem somos</Link></li>
                <li><a href="/#solucoes">Soluções</a></li>
                <li><a href="/#apps">Portfólio</a></li>
              </ul>
            </div>
            <div>
              <h3 className="in-footer__heading">Contato</h3>
              <ul>
                <li><a href="tel:+5544991775641">(44) 99177-5641</a></li>
                <li><a href="mailto:contato@innovanow.com.br">contato@innovanow.com.br</a></li>
                <li>
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=Av.+Presidente+Kennedy%2C+2300%2C+Palotina%2C+PR%2C+85950-000"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Av. Presidente Kennedy, 2300
                  </a>
                </li>
                <li>Palotina — PR · CEP 85950-000</li>
              </ul>
            </div>
            <div>
              <h3 className="in-footer__heading">Redes</h3>
              <ul className="in-footer__social">
                {SOCIAL_LINKS.map((item) => (
                  <li key={item.label}>
                    <a href={item.href} target="_blank" rel="noopener noreferrer">
                      <i className={item.icon} aria-hidden="true" />
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="in-footer__bottom">
            <span>© {new Date().getFullYear()} (in)nova now · CNPJ 53.817.653/0001-24</span>
            <span>Designed by Jean Carlos</span>
          </div>
        </div>
      </footer>
    </>
  );
}
